import { CommonUtility } from '../common';
import { APIPath } from '../constants';
import { BaseService } from './base';
import { CRUDService } from './crud.ts';

class Location extends CRUDService {
  constructor() {
    super(APIPath.inventoryLocation);
  }

  getLocationSummary(id, params) {
    return BaseService.get(
      `${
        APIPath.inventoryLocation
      }/${id}/summary/?${CommonUtility.objectToParams(params)}`,
    );
  }

  checkLocationCanRecieve(payload) {
    return BaseService.post(APIPath.locationMovePreview, payload);
  }

  moveLocation(payload) {
    return BaseService.post(APIPath.locationMove, payload);
  }

  getWarehouseLocationLabel(params) {
    return BaseService.get(
      `${APIPath.locationsGenerateLabels}/?${CommonUtility.objectToParams(params)}`,
    );
  }

  generateWarehouseLocationLabel(payload) {
    return BaseService.post(APIPath.locationsGenerateLabels, payload);
  }

  getLocations(params) {
    return BaseService.get(
      `${APIPath.locations}/?${CommonUtility.objectToParams(params)}`,
    );
  }

  getSourceLocations(params) {
    return BaseService.get(
      `${APIPath.inventoryTransferSourceLocations}/?${CommonUtility.objectToParams(params)}`,
    );
  }

  /** Assign or remove a pallet on a non-picking storage location (WMS). */
  configureLocationPallet(locationId, body) {
    return BaseService.post(`${APIPath.locations}/${locationId}/assign-pallet`, body);
  }
}

const LocationService = new Location();
Object.freeze(LocationService);
export { LocationService };
